import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var StyledDivider = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  border: none;\n  margin: 0;\n"], ["\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  border: none;\n  margin: 0;\n"])), function (_a) {
    var borderWidth = _a.borderWidth, vertical = _a.vertical;
    return vertical ? borderWidth * 0.1 + "rem" : '100%';
}, function (_a) {
    var borderWidth = _a.borderWidth, vertical = _a.vertical;
    return vertical ? '100%' : borderWidth * 0.1 + "rem";
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray3;
});
var templateObject_1;

export { StyledDivider };
